import React from "react";
import { Box, Paper, Stack, Typography, Skeleton } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

/**
 * Tarjetas de resumen de tareas del empleado.
 * Lee directamente las keys que devuelve el endpoint de stats
 * (totalActive, totalPending, totalInProgress, totalCompleted, totalOverdue).
 *
 * El grid usa auto-fit para envolver hacia abajo en pantallas angostas
 * en lugar de desbordar horizontalmente.
 */
const CARDS = [
  { key: "totalActive",     label: "Active Tasks", color: "#2563EB", bg: "#EFF6FF", Icon: AssignmentIcon },
  { key: "totalPending",    label: "Pending",      color: "#D97706", bg: "#FEF3C7", Icon: HourglassEmptyIcon },
  { key: "totalInProgress", label: "In Progress",  color: "#4F46E5", bg: "#EEF2FF", Icon: AutorenewIcon },
  { key: "totalCompleted",  label: "Completed",    color: "#16A34A", bg: "#DCFCE7", Icon: CheckCircleIcon },
  { key: "totalOverdue",    label: "Overdue",      color: "#DC2626", bg: "#FEE2E2", Icon: WarningAmberIcon },
];

export default function EmployeeStatCards({ stats, loading }) {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 1.5,
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(auto-fit, minmax(150px, 1fr))",
        },
      }}
    >
      {CARDS.map(({ key, label, color, bg, Icon }) => (
        <Paper
          key={key}
          elevation={0}
          sx={{ p: 2, borderRadius: 3, border: "1px solid", borderColor: "divider" }}
        >
          <Stack spacing={1}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                bgcolor: bg,
                color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon sx={{ fontSize: 20 }} />
            </Box>
            {loading ? (
              <Skeleton variant="text" width="50%" height={32} />
            ) : (
              <Typography variant="h5" fontWeight={800} sx={{ color, lineHeight: 1.1 }}>
                {stats?.[key] ?? 0}
              </Typography>
            )}
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
              sx={{ textTransform: "uppercase", letterSpacing: 0.5, fontSize: "0.65rem" }}
            >
              {label}
            </Typography>
          </Stack>
        </Paper>
      ))}
    </Box>
  );
}
